import type { SxProps, Theme } from '@mui/material';

export const revealedReadingTitleSx: SxProps<Theme> = {
  mb: 3,
};

export const revealedReadingGridSx = (centered: boolean): SxProps<Theme> => ({
  mb: 3,
  justifyContent: centered ? 'center' : 'flex-start',
});

export const revealedReadingButtonStackSx: SxProps<Theme> = {
  flexDirection: { xs: 'column', sm: 'row' },
  gap: 2,
};
